import BuyContractModule from './Buy'
import SaleContractModule from './Sale'
import MortgageContractModule from './Mortgage'
import EndowmentContractModule from './Endowment'
import RentEstateContractModule from './Rent'
import DonationModule from './Donation'
import PeaceModule from './Peace'
import ExchangeModule from './Exchange'
import MuzarahContractModule from './Muzarah'

export default {
  subModules: {
    buyEstate: BuyContractModule,
    saleEstate: SaleContractModule,
    mortgageEstate: MortgageContractModule,
    endowmentEstate: EndowmentContractModule,
    rentEstate: RentEstateContractModule,
    donationEstate: DonationModule,
    peaceEstate: PeaceModule,
    exchangeEstate: ExchangeModule,
    muzarahEstate: MuzarahContractModule,
  },
}
